<template>
  <transactions-table
    :is-payoutsRegistryItems-loading="isPayoutsRegistryItemsLoading"
    class="payouts-registries-table"
    grid-template-columns="82px 1.2fr 1fr 1.1fr 1.2fr 1fr 140px 60px"
  >
    <template #tableHeader>
      <transactions-table-header
        class="transactions-table__header"
        :header-cols="$options.HEADER_COLS"
        @sortChanged="handleSortChanged"
      ></transactions-table-header>
    </template>
    <template #transactionItems>
      <payouts-registry-main-table-item
        v-for="registryItem in payoutsRegistryItemsPaged"
        :payouts-registry-item="registryItem"
        :key="registryItem.id"
        @repeatPayout="handleRepeatPayout"
      ></payouts-registry-main-table-item>
    </template>
    <template #tablePagination>
      <transactions-table-pagination
        @changePage="handlePageChanged"
        :current-page="currentPage"
        :items-count="payoutsRegistryItemsFiltered.length"
        :per-page="perPage"
      ></transactions-table-pagination>
    </template>
  </transactions-table>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../../utils/gogocodeTransfer'
import TransactionsTable from '@vue-app/components/company/transactions/table/TransactionsTable.vue'
import TransactionsTableHeader from '@vue-app/components/company/transactions/table/TransactionsTableHeader.vue'
import TransactionsTableItem from '@vue-app/components/company/transactions/table/TransactionsTableItem.vue'
import TransactionsTablePagination from '@vue-app/components/company/transactions/table/TransactionsTablePagination.vue'
import PayoutsToCardTableItem from '@vue-app/components/company/payouts/to-card/table/item/PayoutsToCardTableItem.vue'
import PayoutsRegistryTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryTableItem.vue'
import { mapState } from 'vuex'
import PayoutsRegistryCreatedTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryCreatedTableItem.vue'
import PayoutsRegistryMainTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryMainTableItem.vue'

export default {
  name: 'PayoutsRegistryMainTable',
  components: {
    PayoutsRegistryMainTableItem,
    PayoutsRegistryCreatedTableItem,
    PayoutsRegistryTableItem,
    PayoutsToCardTableItem,
    TransactionsTablePagination,
    TransactionsTableItem,
    TransactionsTableHeader,
    TransactionsTable,
  },
  props: {
    payoutsRegistryItems: {
      type: Array,
      default() {
        return []
      },
    },
    isPayoutsRegistryItemsLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
    sort: {
      col: null,
      dir: null,
    },
  }),
  HEADER_COLS: [
    {
      id: 'cardNumber',
      title: 'payouts.by-registry.main.table.column.date',
      additionalClasses: ['transactions-table-header__col--date'],
    },
    {
      id: 'recipient',
      title: 'payouts.by-registry.main.table.column.pan',
      additionalClasses: ['transactions-table-header__col--pan'],
    },
    {
      id: 'pt-id',
      title: 'payouts.by-registry.main.table.column.pt-id',
      additionalClasses: ['transactions-table-header__col--pt-id'],
    },
    {
      id: 'op-id',
      title: 'payouts.by-registry.main.table.column.op-id',
      additionalClasses: ['transactions-table-header__col--op-id'],
    },
    {
      id: 'client',
      title: 'payouts.by-registry.main.table.column.client',
      additionalClasses: ['transactions-table-header__col--client'],
    },
    {
      id: 'sum',
      title: 'payouts.by-registry.main.table.column.sum',
      additionalClasses: ['transactions-table-header__col--sum'],
    },
    {
      id: 'status',
      title: 'payouts.by-registry.main.table.column.status',
      additionalClasses: ['transactions-table-header__col--status'],
    },
    {
      id: 'action',
      title: 'payouts.by-registry.main.table.column.action',
      additionalClasses: ['transactions-table-header__col--action'],
    },
  ],
  computed: {
    ...mapState(['selectedCompany']),
    payoutsRegistryItemsPaged() {
      let _startFrom = (this.currentPage - 1) * this.perPage
      return this.payoutsRegistryItemsFiltered.slice(
        _startFrom,
        _startFrom + this.perPage
      )
    },
    payoutsRegistryItemsFiltered() {
      let _transactionToProcess = [...this.payoutsRegistryItems]

      this.currentPage = 1

      return _transactionToProcess
    },
  },
  methods: {
    handlePayoutsRegistryItemDeleted(payoutsRegistryItem) {
      $emit(this, 'registryPositionDeleted', payoutsRegistryItem)
    },
    handlePayoutsRegistryItemUpdated(payoutsRegistryItem) {
      $emit(this, 'registryPositionUpdated', payoutsRegistryItem)
    },
    handlePageChanged(page) {
      this.currentPage = page
    },
    handleSortChanged(newSort) {
      this.sort = { ...newSort }
    },
    handleRepeatPayout(registryItem) {
      $emit(this, 'repeatPayoutsRegistryItem', registryItem)
    },
  },
  emits: [
    'registryPositionDeleted',
    'registryPositionUpdated',
    'repeatPayoutsRegistryItem',
    ,
  ],
}
</script>

<style lang="scss" scoped>
.payouts-registries-table {
  :deep(.transactions-table) {
    .transactions-table__header {
      padding: 30px 10px;
      background: #ffffff;
      border-radius: 20px 20px 0 0;
      border-bottom: 1px solid #eff2f8;
    }

    .transactions-table__body {
      background: #ffffff;
      border-radius: 0 0 20px 20px;
      padding-bottom: 30px;
    }
  }

  :deep(.transactions-table-header) {
    .transactions-table-header__col {
      .transactions-table-header__col--sum,
      .transactions-table-header__col-commission {
        justify-content: center;
      }

      .transactions-table-header__col--p-sum,
      .transactions-table-header__col--p-count {
        justify-content: flex-end;
      }

      .transactions-table-header__col--status {
        justify-content: center;
      }

      .transactions-table-header__col--action {
        justify-content: center;
      }
    }
  }
}
</style>
